import { unflatten } from 'flat'
import type { FilterForm } from '../types'
import { NestedStringArrayRecord } from '@/services/algolia/types'

type ReducedFilterForm = Omit<FilterForm, 'sort'>

const facetMappings: Record<keyof ReducedFilterForm, string> = {
  band_size: 'filters.options.band_size',
  cup_size: 'filters.options.cup_size',
  size: 'filters.options.size',
  price_ratio: 'filters.price_ratio',
  color: 'filters.meta.lounge.canonical_color',
  tags: 'filters.meta.lounge.product_features',
  category: 'filters.meta.lounge.category',
  categories: 'filters.meta.lounge.categories',
}

export const mapValuesToFacets = (
  values: FilterForm,
): NestedStringArrayRecord =>
  unflatten(
    Object.entries(values).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [facetMappings[key as keyof ReducedFilterForm] ?? key]: value,
      }),
      {},
    ),
  )
